export default "__VITE_ASSET__b02dbfb9__"